export const decimalNumberValidationRegex = '^[0-9]*.?[0-9]*$';
